import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { IoSearch } from "react-icons/io5";
import Navbar from '../Navbar';
import { IoIosClose } from "react-icons/io";
import { VscOutput } from "react-icons/vsc";
import { IoIosArrowDropdown } from "react-icons/io";
import { RiExportFill } from "react-icons/ri";
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import Menu_Items from '../Menu_Items';



function Tables() {
    const { id, int_id, Ex_id } = useParams();

    const [su_admin, setsu_admin] = useState(false)
    const [admin, setadmin] = useState(false)
    const [monitor, setmonitor] = useState(false)
    const [tables, settables] = useState([]);
    const [fieldtable, setfieldtable] = useState([]);
    const [tablenames, settablenames] = useState([]);
    const [fields, setfields] = useState([]);
    const [nonefield, setnonefield] = useState([]);
    const [nonesfield, setnonesfield] = useState([]);
    const [nonehfield, setnonehfield] = useState([]);
    const [export_details, setexport_details] = useState([]);
    const [draggedItem, setDraggedItem] = useState(null);
    const [search_Tables, setsearch_Tables] = useState('');
    const [search_Fields, setsearch_Fields] = useState('');
    const [search_Selected_Fields, setsearch_Selected_Fields] = useState('');
    const [search_Export_Header, setsearch_Export_Header] = useState('');

    const menus = [
        {
            name: 'Integrations',
            id,
        },
        {
            name: 'Out Bound',
            id,
            submenu: [{ name: 'All Out Bounds', id, int_id, type: 'Out' },
            { name: 'Conditions', id, int_id, Ex_id },
            { name: 'Linked Tables', id, int_id, Ex_id },
            { name: 'Config', id, int_id, Ex_id },
            { name: 'Result', id, int_id, Ex_id },
            ]
        },
        (su_admin || admin ? { name: 'Users', id } : { name: null, id })
    ];
    // run first Automatically
    const gettables = async () => {
        await axios.get(`/integ/tables/${int_id}`).then((res) => {
            if (res.data === 'tables Not Fetched') {
                settables([]);
                toast.error("Tables Not Fetched", {
                    autoClose: 2000, // 2 seconds
                });
            }
            else {
                settables(res.data);
            }
        })
            .catch((err) => {
                toast.error("Error", {
                    autoClose: 2000, // 2 seconds
                });
            });
        await axios.get(`/out_bound/export_value/${Ex_id}`).then((res) => {
            let response = res.data;
            let Hvalue = response['Headers'];
            if (Hvalue) {
                let Headers_Value = JSON.parse(Hvalue);
                setexport_details(Headers_Value);
                Headers_Value.forEach((obj) => {
                    table(Object.keys(obj)[0]);
                    Object.values(obj)[0].forEach((item) => {
                        handlefield(Object.keys(obj)[0], item.field);
                    });
                });
            }
            else {
                setexport_details([]);
            }
        })
            .catch((err) => {
                toast.error("Error", {
                    autoClose: 2000, // 2 seconds
                });
            });
    };
    // searcher by Tables
    const filterbyTables = tables.filter(name =>
        name.toLowerCase().startsWith(search_Tables.toLowerCase())
    );
    // // searcher by Fields
    const filteredbyFields = fields.reduce((acc, item) => {
        const k = Object.keys(item)[0]; // Get the table name (key)
        const v = Object.values(item)[0]; // Get the fields (values)

        // If the search term matches the table name, return the whole table
        if (k.toLowerCase().startsWith(search_Fields.toLowerCase())) {
            acc.push({ [k]: v });
        } else {
            // If the search term matches a field, return only that field in the table
            const matchingFields = v.filter(val => val.toLowerCase().startsWith(search_Fields.toLowerCase()));
            if (matchingFields.length > 0) {
                acc.push({ [k]: matchingFields });
            }
        }
        return acc;
    }, []);
    // searcher by Selected Fields
    const filteredDetails = export_details.reduce((acc, obj) => {
        const tname = Object.keys(obj)[0]; // Table name
        const fvalues = Object.values(obj)[0]; // Field values

        // Check if the table name matches the search term
        if (tname.toLowerCase().startsWith(search_Selected_Fields.toLowerCase())) {
            acc.push({ [tname]: fvalues });
        } else {
            // Check if any of the fields match the search term
            const matchingFields = fvalues.filter(fieldObj =>
                fieldObj.field.toLowerCase().startsWith(search_Selected_Fields.toLowerCase())
            );
            if (matchingFields.length > 0) {
                acc.push({ [tname]: matchingFields });
            }
        }

        return acc;
    }, []);
    const filteredbyheader = export_details.reduce((acc, obj) => {
        const tname = Object.keys(obj)[0]; // Table name
        const fvalues = Object.values(obj)[0]; // Field values

        // Check if the table name matches the search term
        if (tname.toLowerCase().startsWith(search_Export_Header.toLowerCase())) {
            acc.push({ [tname]: fvalues });
        } else {
            // Check if any of the fields match the search term
            const matchingFields = fvalues.filter(fieldObj =>
                fieldObj.field.toLowerCase().startsWith(search_Export_Header.toLowerCase())
            );
            if (matchingFields.length > 0) {
                acc.push({ [tname]: matchingFields });
            }
        }

        return acc;
    }, []);
    const table = async (name) => {
        if (tablenames.includes(name)) {
            setfields(prevData => prevData.filter(item => !item.hasOwnProperty(name)));
            setexport_details(prevData => prevData.filter(item => !item.hasOwnProperty(name)));
            setfieldtable(fieldtable.filter(item => item !== name));
            settablenames(tablenames.filter(item => item !== name));
        }
        else {
            await axios.get(`/integ/field/${name}/${int_id}`, name).then((res) => {
                let values = res.data;
                setfields(prevState => [...prevState, { [name]: values }]);
            })
                .catch((err) => {
                    toast.error("Fields Fetched Error", {
                        autoClose: 2000, // 2 seconds
                    });
                });
            settablenames(prevState => [...prevState, name]);
        }
    };
    const handlefield = (key, value) => {
        if (fieldtable.includes(`${key}${value}`)) {
            setfieldtable((prevData) => prevData.filter((val) => val !== `${key}${value}`));
        }
        else {
            setfieldtable((prevData) => [...prevData, `${key}${value}`]);
        }

    };
    const export_fields = (t, f) => {

        if (export_details.length === 0) {
            setexport_details([{ [t]: [{ 'field': f, 'alias': f }] }]);
        }
        else {
            let Existsval = export_details.some(item => t in item);
            if (!Existsval) {
                setexport_details([...export_details, { [t]: [{ 'field': f, 'alias': f }] }]);
            }
            else {
                const exists = checkIfFieldExists(export_details, t, f);
                if (!exists) {
                    const updatedval = export_details.map(obj => {
                        if (obj[t]) {
                            return {
                                ...obj,
                                [t]: [...obj[t], { field: f, alias: f }]
                            };
                        }
                        return obj;
                    });

                    setexport_details(updatedval);
                }
                else {
                    const updatedArray = removeFieldFromArray(export_details, t, f);
                    setexport_details(updatedArray);
                }
            }
        }
    };
    const checkIfFieldExists = (arr, t, f) => {
        const obj = arr.find(item => item[t]);
        return obj && obj[t].some(item => item.field === f);
    }
    const removeFieldFromArray = (arr, key, fieldValue) => {
        return arr.map(item => {
            if (item[key]) {
                return {
                    [key]: item[key].filter(subItem => subItem.field !== fieldValue)
                };
            }
            return item;
        });
    };
    const export_header = (t, f, e, index) => {
        const updatedData = export_details.map(item => {
            if (item[t]) {
                return {
                    ...item,
                    [t]: item[t].map((field, i) => (
                        i === index ? { ...field, alias: e } : field
                    ))
                };
            }
            return item;
        });

        setexport_details(updatedData);

    };
    // None For Fields
    const fnone = (id) => {
        setnonefield(prevState =>
            prevState.includes(id) ? prevState.filter(divId => divId !== id) : [id]
        );
    };
    // None For Selected Fields
    const snone = (id) => {
        setnonesfield(prevState =>
            prevState.includes(id) ? prevState.filter(divId => divId !== id) : [id]
        );
    };
    // None For Export Headers
    const hnone = (id) => {
        setnonehfield(prevState =>
            prevState.includes(id) ? prevState.filter(divId => divId !== id) : [id]
        );
    };
    // Handle dragging start event
    const onDragStart = (e, draggedField, draggedTname, draggedIndex) => {
        setDraggedItem({ draggedField, draggedTname, draggedIndex });
    };
    // Handle drag over event to allow drop
    const onDragOver = (e) => {
        e.preventDefault(); // Necessary to allow dropping
    };
    // Handle dropping event
    const onDrop = (e, dropTname, dropIndex) => {
        e.preventDefault();
        if (draggedItem && dropTname === draggedItem.draggedTname) {
            const updatedFields = [...export_details];

            // Find the index of the current table
            const tableIndex = updatedFields.findIndex((obj) => Object.keys(obj)[0] === dropTname);

            if (tableIndex !== -1) {
                let fieldArray = updatedFields[tableIndex][dropTname];

                // Reorder the fields array
                const [removed] = fieldArray.splice(draggedItem.draggedIndex, 1); // Remove dragged item
                fieldArray.splice(dropIndex, 0, removed); // Insert it at the drop position

                updatedFields[tableIndex][dropTname] = fieldArray;
                setDraggedItem(null); // Clear the dragged item
            }
        }
    };
    const export_header_sumit = async () => {
        let headers = JSON.stringify(export_details);
        let value = {
            Headers: headers
        };
        await axios.patch(`/out_bound/headers/${Ex_id}`, value).then((res) => {
            toast.success('Headers Successfully Updated', {
                autoClose: 2000,
            })

        })
            .catch((err) => {
                toast.error("headers Updated error", {
                    autoClose: 2000, // 2 seconds
                });
            });
    };
    const get_level = () => {
        const level = Cookies.get("level");
        if (level === "Super Admin") {
            setsu_admin(true);
        }
        else if (level === 'Admin') {
            setadmin(true)
        }
        else {
            setmonitor(true)
        }

    };
    useEffect(() => {
        gettables();
        get_level();
    }, []);

    return (
        <div className='container df fdc jb ac'>
            <Navbar />
            <div className='main_box df'>
                <Menu_Items menu={menus} />
                <div className='content df fdc ac'>
                    <div className='page_header df jb ac'>
                        <div className='w90 df ac'>
                            <RiExportFill className='page_icon db' />
                            <p>Table Headers</p>
                        </div>
                    </div>
                    <div className='box df jc ac'>
                        <div className='t_box1'>
                            <div className='box1_h df jc ac'>
                                <p className='df jc ac'>Tables</p>
                            </div>
                            <div className='box1_con df fdc ac'>
                                <div className='table_search df jc ac'>
                                    <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                    <input type='search' id='ser_table' placeholder='Search' onChange={e => setsearch_Tables(e.target.value)} />
                                </div>
                                {filterbyTables.length > 0 && filterbyTables.map((name, index) => {
                                    let val = name.charAt(0).toUpperCase() + name.slice(1);
                                    return (
                                        <div className="con df gap ac w80" key={`table${index}`}>
                                            <input
                                                type="checkbox"
                                                onChange={() => { table(name); }}
                                                id={index}
                                                checked={tablenames.includes(name)}
                                                disabled={monitor}
                                            />
                                            <label htmlFor={index}>{val}</label>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className='t_box2'>
                            <div className='box1_h df jc ac'>
                                <p className='df jc ac'>Fields</p>
                            </div>
                            <div className='box1_con df fdc ac'>
                                <div className='table_search df jc ac'>
                                    <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                    <input type='search' id='ser_field' placeholder='Search' onChange={e => setsearch_Fields(e.target.value)} />
                                </div>
                                {
                                    filteredbyFields.length > 0 ? (
                                        filteredbyFields.map((item, itemIndex) => {
                                            let k = Object.keys(item);
                                            let v = Object.values(item);
                                            let tablename = k[0].charAt(0).toUpperCase() + k[0].slice(1);

                                            return v.map((values, valueIndex) => (
                                                <React.Fragment key={`${itemIndex}-${valueIndex}`}>
                                                    <div className="g fields_h df jb ac">
                                                        <p>{tablename}</p>
                                                        <IoIosArrowDropdown
                                                            className="db"
                                                            onClick={() => {
                                                                fnone(`f${k[0]}`);
                                                            }}
                                                        />
                                                    </div>
                                                    {values.map((val, valIndex) => {
                                                        let field = val.charAt(0).toUpperCase() + val.slice(1);
                                                        return (
                                                            <div
                                                                id={`${nonefield.includes(`f${k[0]}`) ? 'block' : 'none'
                                                                    }`}
                                                                className="con fields w80"
                                                                key={`${itemIndex}-${valueIndex}-${valIndex}`}
                                                            >
                                                                <div className="df ac gap">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`${k[0]}${val}`}
                                                                        onChange={() => {
                                                                            handlefield(k[0], val);
                                                                            export_fields(k[0], val);
                                                                        }}
                                                                        checked={fieldtable.includes(`${k[0]}${val}`)}
                                                                        disabled={monitor}
                                                                    />
                                                                    <label htmlFor={`${k[0]}${val}`}>{field}</label>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </React.Fragment>
                                            ));
                                        })
                                    ) : <p className='no_Records h50 w100 df jc ac '>No results found</p>
                                }
                            </div>
                        </div>
                        <div className='t_box3 '>
                            <div className='box1_h df jc ac'>
                                <p className='df jc ac'>Selected Fields</p>
                            </div>
                            <div className='box1_con df fdc ac'>
                                <div className='table_search df jc ac'>
                                    <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                    <input type='search' id='ser_field' placeholder='Search' onChange={e => setsearch_Selected_Fields(e.target.value.toLowerCase())} />
                                </div>
                                {
                                    filteredDetails.length > 0 ? (
                                        filteredDetails.map((obj, index) => {
                                            let tname = Object.keys(obj)[0];
                                            let fvalues = Object.values(obj)[0];
                                            let tableName = tname.charAt(0).toUpperCase() + tname.slice(1);
                                            return (
                                                <React.Fragment key={`table${index}`}>
                                                    <div className='m05 g fields_h df jb ac'>
                                                        <p>{tableName}</p>
                                                        <IoIosArrowDropdown className='db' onClick={() => { snone(`s${tname}`) }} />
                                                    </div>
                                                    {fvalues.map((item, i) => {
                                                        let field = item.field.charAt(0).toUpperCase() + item.field.slice(1);
                                                        return (
                                                            <div
                                                                key={`${field}-${i}`}
                                                                id={`${nonesfield.includes(`s${tname}`) ? 'show' : 'none'}`}
                                                                className='m1 h3 w90 df jb ac'
                                                                draggable="true"
                                                                onDragStart={(e) => onDragStart(e, item, tname, i)}
                                                                onDragOver={onDragOver}
                                                                onDrop={(e) => onDrop(e, tname, i)}
                                                            >
                                                                <p className='w80 bb'>{field}</p>
                                                                {
                                                                    !monitor && <IoIosClose className='r h2 w10 df jc ac' onClick={() => export_fields(tname, item.field)} />
                                                                }


                                                            </div>
                                                        );
                                                    })}
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <p className='no_Records h50 w100 df jc ac '>No results found</p>
                                    )
                                }

                            </div>
                        </div>
                        <div className='t_box4'>
                            <div className='box1_h df jc ac'>
                                <p className='df jc ac'>Table Headers</p>
                            </div>
                            <div className='box1_con df fdc ac'>
                                <div className='table_search df jc ac'>
                                    <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                    <input type='search' id='ser_field' placeholder='Search' onChange={e => setsearch_Export_Header(e.target.value)} />
                                </div>
                                <div className='ex_body df fdc ac gap'>
                                    {filteredbyheader.length > 0 ? (
                                        filteredbyheader.map((obj, index) => {
                                            let tname = Object.keys(obj)[0];
                                            let fvalues = Object.values(obj)[0];
                                            let tableName = tname.charAt(0).toUpperCase() + tname.slice(1);

                                            return (
                                                <React.Fragment key={`table${index}`}>
                                                    <div className='m05 g fields_h df jb ac'>
                                                        <p>{tableName}</p>
                                                        <IoIosArrowDropdown className='db' onClick={() => { hnone(`h${tname}`) }} />
                                                    </div>
                                                    {fvalues.map((item, i) => {
                                                        let field = item.field.charAt(0).toUpperCase() + item.field.slice(1);
                                                        return (
                                                            <div className='w80 df fdc h6' id={`${nonehfield.includes(`h${tname}`) ? 'block' : 'none'}`} key={i}>
                                                                <label>{field}</label>
                                                                <input
                                                                    type='search'
                                                                    id={item.alias}
                                                                    className='ex_input db'
                                                                    onChange={(e) => export_header(tname, item.field, e.target.value, i)}
                                                                    value={item.alias}
                                                                    placeholder={item.alias}
                                                                    disabled={monitor}
                                                                />
                                                            </div>
                                                        );
                                                    })}
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <div className='no_Records h75 w100 df jc ac'><p>No results found</p></div>
                                    )}
                                </div>
                            </div>
                            {
                                !monitor && filteredbyheader.length > 0 && <div className='ex_submit df jc ac'>
                                    <button className='btn green' onClick={export_header_sumit}>Submit</button>
                                </div>
                            }

                        </div>
                    </div>
                </div>
            </div>
            {/* <div className='h_btn df jc ae'>
                <p className='df jc ac'>Out Bound Headers</p>
                <div className='menu_bar h5 w25 df je ac gap1'>
                    <Link to={home_path} className='menu_icon df jc ac' ><AiFillHome className='icon2' /></Link>
                    <Link to={`/out_bound_details/${id}/${int_id}`} className='menu_icon df jc ac' ><IoChevronBackCircleSharp className='icon2' /></Link>

                    {
                        (admin_level) &&
                        <>
                            <Link to={`/company/users/${id}`} className='menu_icon df jc ac'><FaUsers className='icon2' /></Link>
                            <Link to={`/integ/${id}`} className='menu_icon df jc ac'><SiGitconnected className='icon2' /></Link>
                        </>
                    }
                    {
                        (admin_level || user_level) &&
                        <>
                            <Link to={`/out_bound/conditions/${id}/${int_id}/${E_id}`} className='menu_icon df jc ac'><FaCopyright className='icon2' /></Link>
                            <Link to={`/out_bound/fieldmapping/${id}/${int_id}/${E_id}`} className='menu_icon df jc ac'><FaMedium className='icon2' /></Link>
                        </>


                    }
                    <Link to={"/"} className='menu_icon df jc ac' ><MdLogout className='icon2' /></Link>
                </div>
            </div> */}
            {/* <div className='t_box df jc ac'> */}

            {/* </div> */}
            {/* <Back location={`/out_bound_details/${id}/${int_id}`} /> */}
        </div >
    )
}

export default Tables;